import React from 'react';
import { Calendar, Trophy, CheckSquare, Sparkles } from 'lucide-react';

// Sunday — Test & Revision Day card for Tracker 360.
// Checklist state is persisted by the parent (localStorage), keyed by date.

const CHECKLIST = [
  {
    key: 'mock',
    title: 'Full Syllabus or Part Mock Test',
    hint: 'Attempt one mock test (JEE Main level).',
  },
  {
    key: 'analyse',
    title: 'Analyse Mistakes',
    hint: 'Find weak topics and note them.',
  },
  {
    key: 'revise',
    title: 'Revision of Weak Topics',
    hint: 'Revise notes, formulas and short notes.',
  },
  {
    key: 'update',
    title: 'Update Tracker',
    hint: 'Mark completed and update progress.',
  },
];

export default function SundayRevisionCard({ date, checks, onToggle }) {
  const doneCount = CHECKLIST.filter((c) => checks?.[c.key]).length;

  return (
    <div className="relative overflow-hidden rounded-2xl border border-amber-300/60 dark:border-amber-500/30 bg-gradient-to-br from-amber-400 via-orange-400 to-amber-500 dark:from-amber-950/80 dark:via-orange-950/60 dark:to-amber-900/70 shadow-lg shadow-amber-500/25 dark:shadow-[0_10px_40px_-15px_rgba(245,158,11,0.35)]">
      {/* Decorative elements */}
      <div className="pointer-events-none absolute -top-10 -right-10 w-40 h-40 rounded-full bg-white/20 dark:bg-amber-400/10 blur-2xl" />
      <div className="pointer-events-none absolute -bottom-12 -left-8 w-36 h-36 rounded-full bg-yellow-200/30 dark:bg-orange-500/10 blur-2xl" />
      <Sparkles className="pointer-events-none absolute top-4 right-16 w-4 h-4 text-white/50 dark:text-amber-300/40" />
      <Sparkles className="pointer-events-none absolute bottom-16 right-6 w-3 h-3 text-white/40 dark:text-amber-300/30" />

      <div className="relative p-5">
        <div className="flex items-start justify-between gap-3 mb-1">
          <div className="flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-white/25 dark:bg-amber-400/15 border border-white/40 dark:border-amber-400/25 text-white dark:text-amber-300 shadow-sm">
              <Calendar className="w-5 h-5" />
            </span>
            <div>
              <h4 className="font-black text-base text-white dark:text-amber-100 drop-shadow-sm">
                Sunday – Test &amp; Revision Day
              </h4>
              <p className="text-[11px] font-semibold text-amber-50/90 dark:text-amber-200/70">
                Weekly Mock Test • Revision • Performance Analysis
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center gap-1 flex-shrink-0">
            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-white/20 dark:bg-amber-400/10 border border-white/30 dark:border-amber-400/20 text-yellow-100 dark:text-amber-300">
              <Trophy className="w-5 h-5" />
            </span>
            <span className="text-[10px] font-black text-white/90 dark:text-amber-200/80">
              {doneCount}/{CHECKLIST.length}
            </span>
          </div>
        </div>

        <p className="text-[11px] font-medium text-amber-50/80 dark:text-amber-200/60 mb-3">{date}</p>

        <div className="space-y-2">
          {CHECKLIST.map((item, idx) => {
            const done = !!checks?.[item.key];
            return (
              <button
                key={item.key}
                type="button"
                onClick={() => onToggle(item.key)}
                aria-pressed={done}
                className={`w-full flex items-center gap-3 p-3 rounded-xl border text-left transition-all ${
                  done
                    ? 'bg-white/90 dark:bg-amber-400/15 border-white dark:border-amber-400/40 shadow-sm'
                    : 'bg-white/15 dark:bg-white/[0.04] border-white/30 dark:border-amber-400/15 hover:bg-white/25 dark:hover:bg-white/[0.07]'
                }`}
              >
                <span
                  className={`grid h-5 w-5 place-items-center rounded-md border flex-shrink-0 transition ${
                    done
                      ? 'bg-emerald-500 border-emerald-500 text-white'
                      : 'bg-white/40 dark:bg-transparent border-white/60 dark:border-amber-300/30 text-transparent'
                  }`}
                >
                  <CheckSquare className="w-3.5 h-3.5" />
                </span>
                <span className="flex-1 min-w-0">
                  <span
                    className={`block text-xs font-bold leading-tight ${
                      done
                        ? 'text-amber-900 dark:text-amber-100 line-through opacity-80'
                        : 'text-white dark:text-amber-50'
                    }`}
                  >
                    {idx + 1}. {item.title}
                  </span>
                  <span
                    className={`block text-[10px] font-medium mt-0.5 ${
                      done ? 'text-amber-700/70 dark:text-amber-200/50' : 'text-amber-50/80 dark:text-amber-200/50'
                    }`}
                  >
                    {item.hint}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
